import { AllocateJobEngine } from '@warebee/frontend/data-access-api-graphql';
import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState } from 'recoil';
import DropdownSelector from '../../../components/actions/DropdownSelector';
import TitleSection from '../../../components/layout/TitleSection';
import { allocateJobEngineState } from '../../../simulation/store/allocation/allocation.state';

export const SettingsEngineAllocate: React.FC = () => {
  const { t } = useTranslation('simulation');
  const [engineAllocate, setEngineAllocate] = useRecoilState(
    allocateJobEngineState,
  );

  // console.debug('engineAllocate:', engineAllocate);

  const allocateRunOptions: Record<
    AllocateJobEngine,
    { title: string; desc: string }
  > = {
    [AllocateJobEngine.LAMBDA]: {
      title: t`L - Engine`,
      desc: t`Lambda`,
    },
    [AllocateJobEngine.FARGATE]: {
      title: t`F - Engine`,
      desc: t`Fargate`,
    },
  };

  return (
    <TitleSection
      id="settings-engine-allocate"
      inPanelView
      title={t`Allocation Settings (Advanced)`}
      classNameInner="p-4"
      collapsible
    >
      <DropdownSelector
        classNameLabel={classNames('text-xxs xl:text-sm flex-1')}
        className={classNames('ltr:mr-0.5 xl:ltr:mr-2 rtl:ml-0.5 xl:rtl:ml-2')}
        DropAlignRight
        widthFull
        headerMode
        label={t`Allocate Engine`}
        values={[AllocateJobEngine.LAMBDA, AllocateJobEngine.FARGATE]}
        value={engineAllocate}
        onChange={(value: AllocateJobEngine) => {
          console.log('AllocateJobEngine (Before):', value);
          setEngineAllocate(value);
          console.log('AllocateJobEngine (After):', value);
        }}
        renderValue={i => allocateRunOptions[i]?.title}
      />
    </TitleSection>
  );
};
